'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivateDataComponent = function PrivateDataComponent(_ref) {
  var post = _ref.post;

  var influencerName = post.channelTitle || post.influencerName || post.twitterHandle;
  var hostname = _lodash2.default.toLower(window.location.hostname);
  var platformName = hostname.match(/voxogram/) ? 'voxogram' : 'dyzio';

  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'grey' }),
    content: influencerName + ' has not authorised ' + platformName + ' to fetch this data.'
  });
};

exports.default = PrivateDataComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/private-data-component/index.js
 ** module id = 382
 ** module chunks = 0
 **/